
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m1.80005 12c0-5.62008 4.55607-10.20001 10.17735-10.20001 5.6206 0 10.2 4.57934 10.2 10.20001 0 2.1272-.6478 4.1864-1.8972 5.9218l-.0023.0032-.1848.2464.1941.2749c.556.8802 1.1333 1.6658 1.6452 2.3126.19.2402.371.4611.5383.6607.0383.0456.0759.0901.1127.1335.0504.0595.0617.1427.029.2135-.0328.0707-.1036.1159-.1815.1159h-.1134c-.3081 0-.6265-.0128-.9535-.0378-1.314-.1004-2.7708-.398-4.2529-.8554l-.0043-.0013-.1894-.0632-.176.096c-1.4563.7628-3.098 1.1792-4.7414 1.1792-5.62061 0-10.19995-4.5793-10.19995-10.2zm10.17735-9.01421c-4.96289 0-8.99155 4.04554-8.99155 9.01421 0 4.9657 4.04844 9.0142 9.01415 9.0142 1.4432 0 2.8939-.3658 4.1841-1.0402l.5421-.2956c.0488-.0266.1063-.0317.159-.0142l.586.1952c.9659.2976 1.9081.5202 2.7916.6607-.3174-.4368-.644-.9122-.9647-1.4188l-.5874-.832c-.05-.0709-.0487-.166.0034-.2354l.6092-.8124c1.0974-1.5277 1.6683-3.3406 1.6683-5.2215 0-4.96577-4.0485-9.01421-9.0142-9.01421zm-1.1508 11.36521v-1.0313h-.97769v-5.03329h-.29544-.99914-.0376l-3.37342 5.28569.04297.7789h3.36805v1.7566h1.29458v-1.7566zm-2.27227-4.35316-.12355.21166-1.93918 3.1102h2.06273zm6.02707 1.14096-1.6599-2.85239h-1.5578l2.3689 3.87299-2.428 3.9482h1.5739l1.7029-2.9061 1.7028 2.9061h1.5685l-2.4226-3.9482 2.3635-3.87299h-1.5524z","fill":"#4a3428","fill-rule":"evenodd"}})])
          )
        }
      }
    